// Components
import { StepIntegrationLinkedinComponent } from './step-integration-linkedin.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_INTEGRATION_LINKED_IN = {
  stepIdentifier: 'mediaUploadFlowStepIntegrationLinkedIn',
  identifier: 'linkedin',
  component: StepIntegrationLinkedinComponent,
  name: 'LinkedIn',
  title: 'LinkedIn Configuration',
  header: true,
  headerDistinctive: true,
  displayInFlowProgressBar: true,
  canNavigateBack: false,
  subStep: true,
} as MediaUploadFlowStep;
